import { render } from "./PropertyAgencyInfo.vue?vue&type=template&id=60b34cc4&scoped=true"
import script from "./PropertyAgencyInfo.vue?vue&type=script&lang=js"
export * from "./PropertyAgencyInfo.vue?vue&type=script&lang=js"

import "./PropertyAgencyInfo.vue?vue&type=style&index=0&id=60b34cc4&scoped=true&lang=css"

import exportComponent from "/var/www/html/webmobtuts/realestateapp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60b34cc4"]])

export default __exports__